import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { toggleUploadModal, userRegister, userLogin } from "../../actions";
import UploadModalContainer from "./UploadModalContainer";
import "./UploadModal.css";

class UploadModal extends React.Component {
  handleCloseModal = () => {
    this.props.toggleUploadModal(false);
  };

  render() {
    return (
      <div className="modal modal--upload upload">
        <UploadModalContainer
          handleCloseModal={this.handleCloseModal}
          type={this.props.type}
          user={this.props.user}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    type: state.upload.type,
  };
}

function mapDispatchToProps(dispatch) {
  // Pass result of selectToolCollection to reducers
  return bindActionCreators(
    {
      toggleUploadModal,
      userRegister: userRegister.request,
      userLogin: userLogin.request,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(UploadModal);
